<template>
  <div id="alignment-wrap">
    <h3>Alignment</h3>
    <p>{{ (morality === 'Neutral' && place === 'Neutral') ? 'True Neutral' : place + ' ' + morality }}</p>
    <div class="alignment-table">
      <div v-for="i in 3" :key="i" class="alignment-table-row">
        <div
          v-for="j in 3"
          :key="j"
          :class="'alignment-table-col ' + `table-cell-${i}-${j}`"
          @click="clickTable(i, j)"
        >{{ alignment == i + '' + j ? 'X' : ''}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CharacterAlignment",
  data() {
    return {
      morality: "Neutral",
      place: "Neutral"
    };
  },
  mounted() {
    let al = this.$store.getters.getAlignment;
    this.clickTable(Number(al[0]), Number(al[1]));
  },
  methods: {
    clickTable: function(i, j) {
      // this.alignment = '';
      switch (i) {
        case 1:
          this.place = "Lawful";
          break;
        case 2:
          this.place = "Neutral";
          break;
        case 3:
          this.place = "Chaotic";
          break;
      }

      switch (j) {
        case 1:
          this.morality = "Good";
          break;
        case 2:
          this.morality = "Neutral";
          break;
        case 3:
          this.morality = "Evil";
          break;
      }

      this.alignment = i + "" + j;
    }
  },
  computed: {
    alignment: {
      get() {
        return this.$store.getters.getAlignment;
      },
      set(value) {
        this.$store.commit("updateCharacterProperty", {
          type: "alignment",
          property: value
        });
      }
    }
  }
};
</script>
<style lang="css">
#alignment-wrap p {
  text-align: center;
}

.alignment-table-row {
  display: flex;
  /* align-items: center; */
}

.alignment-table-col {
  width: 1.7em;
  height: 1.7em;
  margin: 0.3em;
  font-size: 20px;
  border: 1px solid black;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>